export default {"testimonial2":"q5Dwg","testimonial2Title":"z0Ii1","testimmonial2Slider":"m-qZ6","sliderLoaded":"_2-tI-"};